import { toppings, extras, drinks } from '../../../mocks/menu';

const MENU_IMAGE = 'https://static.readdy.ai/image/fe9af1ed768c21ad7118d7d5eb00ae7d/c72e0de19bc3b350bf9557209d4e121d.png';
const BENI_TSURU_IMAGE = 'https://static.readdy.ai/image/fe9af1ed768c21ad7118d7d5eb00ae7d/e5ef9880367c4c300dd95285a4ac5c5b.png';
const CHARSHU_IMAGE = 'https://static.readdy.ai/image/fe9af1ed768c21ad7118d7d5eb00ae7d/8e69cd6a8f046d8e5394d1094181ab50.png';
const SPECIAL_IMAGE = 'https://static.readdy.ai/image/fe9af1ed768c21ad7118d7d5eb00ae7d/09befad47f855661726b13200b5bdaa9.png';

const menuItems = [
  {
    name: '豚骨醤油ラーメン',
    description: '豚骨と醤油の絶妙なバランス。深いコクと旨味が凝縮された定番の一杯。',
    price: '850',
    image: MENU_IMAGE,
    imgStyle: {
      position: 'absolute' as const,
      top: '0px',
      left: '0px',
      width: '100%',
      height: '100%',
      objectFit: 'cover' as const,
      objectPosition: 'center 60%' as const,
    },
  },
  {
    name: '豚骨醤油スペシャル',
    description: '定番の豚骨醤油に特製トッピングをプラス。チャーシュー・味玉・海苔が贅沢に乗った特別な一杯。',
    price: '1100',
    image: SPECIAL_IMAGE,
    imgStyle: {
      position: 'absolute' as const,
      top: '0px',
      left: '0px',
      width: '100%',
      height: '100%',
      objectFit: 'cover' as const,
      objectPosition: 'center' as const,
    },
  },
  {
    name: '紅鶴ラーメン',
    description: '激辛！特製辛味噌と豚骨スープが融合。辛さの中に旨味が広がる鶴の看板メニュー。',
    price: '1100',
    image: BENI_TSURU_IMAGE,
    imgStyle: {
      position: 'absolute' as const,
      top: '0px',
      left: '0px',
      width: '100%',
      height: '100%',
      objectFit: 'cover' as const,
      objectPosition: 'center' as const,
    },
  },
  {
    name: '豚骨醤油チャーシュー',
    description: '自家製チャーシューをたっぷりトッピング。肉好きにはたまらない贅沢な一杯。',
    price: '1200',
    image: CHARSHU_IMAGE,
    imgStyle: {
      position: 'absolute' as const,
      top: '0px',
      left: '0px',
      width: '100%',
      height: '100%',
      objectFit: 'cover' as const,
      objectPosition: 'center' as const,
    },
  },
];

export default function Menu() {
  return (
    <section id="menu" className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'serif' }}>
            お品書き
          </h2>
          <p className="text-sm text-gray-500 tracking-widest mb-4">MENU</p>
          <div className="w-16 h-0.5 bg-red-800 mx-auto"></div>
        </div>

        {/* メインメニュー */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {menuItems.map((item, index) => (
            <div
              key={index}
              className="bg-amber-50 rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="h-56 w-full overflow-hidden relative">
                <img
                  src={item.image}
                  alt={item.name}
                  style={item.imgStyle}
                />
              </div>
              <div className="p-5">
                <h3 className="text-lg font-bold text-gray-900 mb-2">{item.name}</h3>
                <p className="text-xs text-gray-600 leading-relaxed mb-4">{item.description}</p>
                <p className="text-2xl font-bold text-red-800 text-right" style={{ fontFamily: 'serif' }}>
                  ¥{item.price}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* トッピング・サイドメニュー */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-amber-50 rounded-2xl p-6 shadow-md">
            <h3 className="text-base font-bold text-gray-900 mb-4 flex items-center gap-2">
              <span className="w-1 h-5 bg-red-800 rounded-full inline-block"></span>
              トッピング
            </h3>
            <ul className="space-y-3">
              {toppings.map((t, i) => (
                <li key={i} className="flex justify-between items-center text-sm">
                  <span className="text-gray-700">{t.name}</span>
                  <span className="font-bold text-red-800">¥{t.price}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-amber-50 rounded-2xl p-6 shadow-md">
            <h3 className="text-base font-bold text-gray-900 mb-4 flex items-center gap-2">
              <span className="w-1 h-5 bg-red-800 rounded-full inline-block"></span>
              サイドメニュー
            </h3>
            <ul className="space-y-3">
              {extras.map((e, i) => (
                <li key={i} className="flex justify-between items-center text-sm">
                  <span className="text-gray-700">{e.name}</span>
                  <span className="font-bold text-red-800">¥{e.price}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-amber-50 rounded-2xl p-6 shadow-md">
            <h3 className="text-base font-bold text-gray-900 mb-4 flex items-center gap-2">
              <span className="w-1 h-5 bg-red-800 rounded-full inline-block"></span>
              飲み物
            </h3>
            <ul className="space-y-3">
              {drinks.map((d, i) => (
                <li key={i} className="flex justify-between items-center text-sm">
                  <span className="text-gray-700">{d.name}</span>
                  <span className="font-bold text-red-800">¥{d.price}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
